






























































import Enumerable from "linq";
import { Vue, Component, Mixins, Watch, Prop } from "vue-property-decorator";
import { IWizard, IWizardPage } from "../../../../domain/format";
import { default as CommonComponentsContainer } from "../CommonComponentsContainer.vue";
import { ICommonComponentsContainable } from "../ICommonComponentsContainable";
import { DocumentEditorMixin } from "../mixins";
import { DocumentPageEditor, DocumentPageNavigator, DocumentEditNavigator, DocumentRegisteredNavigator, DocumentScaleSelector } from "./contents";
import { IDocumentAlert } from "../../../../domain/document";
import { AlertDialog, UnlockDialog } from "./contents/dialogs";

@Component({
  components: {
    CommonComponentsContainer,
    DocumentPageEditor,
    DocumentScaleSelector,
    DocumentPageNavigator,
    DocumentEditNavigator,
    DocumentRegisteredNavigator,
    AlertDialog,
    UnlockDialog,
  },
})
export default class DocumentEditor extends Mixins(DocumentEditorMixin) implements ICommonComponentsContainable {
  $refs!: {
    commonComponents: Vue;
    alertDialog: AlertDialog;
    unlockDialog: UnlockDialog;
  };

  @Prop()
  isRegistered: boolean;

  @Prop({ default: false })
  shouldValidateExistingLinkedDocument: boolean;

  @Prop()
  authenticate: (isForcibly: boolean) => Promise<boolean>;

  @Prop({ default: () => [] as { label: string, process: () => void }[] })
  registeredOperations: { label: string, process: (unlock: () => Promise<boolean>) => void }[];

  @Prop()
  wizard: IWizard;

  get shouldAuthenticateOnRegistration(): boolean {
    return (this.wizard && this.wizard.registration && this.wizard.registration.shouldAuthenticate);
  }

  mounted() {
    this.$registerCloseHandler(this.deleteCreateToken);
  }

  getCommonComponentsContainer(): Vue {
    return this.$refs.commonComponents as Vue;
  }

  data() {
    return {
      pageIndex: 0,
      maxAccessedPageIndex: 0,
      userCode: this.$store.getters.user.id,
      scale: 1,
    };
  }
  pageIndex: number;
  maxAccessedPageIndex: number;
  userCode: string;
  scale: number;

  get isDocumentAlreadyInitialized(): boolean {
    return this.document
        && this.document.isAlreadyInitialized;
  }

  get isHeaderVisible(): boolean {
    return this.isScaleSelectable;
  }

  get scales(): number[] {
    return this.wizard && this.wizard.attributes && this.wizard.attributes.scales ? this.wizard.attributes.scales : [];
  }

  get isScaleSelectable(): boolean {
    return 1 < this.scales.length;
  }

  get contentsStyle() {
    return {
      fontSize: this.wizard.attributes.fontSize ? `calc(${this.wizard.attributes.fontSize}*${this.scale})` : undefined,
    };
  }

  get wizardPage(): IWizardPage {
    return this.wizardPages[this.pageIndex];
  }

  get wizardPages(): IWizardPage[] {
    return this.wizard
      ? this.isRegistered
        ? this.wizard.registeredPages
        : this.wizard.pages
      : [];
  }

  get lastPageIndex(): number {
    return Enumerable.range(this.wizardPages.length - 1, this.wizardPages.length, -1)
      .firstOrDefault(i => this.wizard.pages[i].isEnable(this.document.source), -1);
  }

  get isLastPageAlreadyAccessed(): boolean {
    return this.lastPageIndex <= this.maxAccessedPageIndex;
  }

  get documentAlerts(): IDocumentAlert[] {
    return (this.document && !!this.document.alerts) ? this.document.alerts : [];
  }

  get complementedRegisteredOperations(): { label: string, process: () => void }[] {
    return this.registeredOperations.map(o => ({
      label: o.label,
      process: () => o.process(() => this.unlock()),
    }));
  }

  onMounted() {
    if (0 < this.scales.length) {
      this.initializeScale();
    }
  }

  private initializeScale() {
    this.scale = 0 < this.scales.length && this.scales.some(s => s === 1) ? 1 : this.scales[0];
  }

  async unlock(): Promise<boolean> {
    return this.$refs.unlockDialog.show();
  }

  onDocumentRegistered(id: number, destinationRoute?: any, isTemporary?: boolean, archiveId?: number) {
    this.clearCreateTokenTimer();
    this.clearWriteTokenTimer();
    this.documentRegistered(id, destinationRoute, isTemporary, archiveId);
  }

  async deleteCreateToken(): Promise<void> {
    this.clearCreateTokenTimer();
    await this.deleteDocumentCreateToken();
  }

  /**
   * DocumentEditorMixinに移動してdestroyed()からも呼ぶようにしたほうが安全なように見える
   */
  clearCreateTokenTimer(): void {
    if (!this.createTokenTimer) { return; }
    clearInterval(this.createTokenTimer);
    this.createTokenTimer = null;
  }

  async authenticateManagement(): Promise<boolean> {
    try {
      return await this.$refs.unlockDialog.show();
    } catch (e) {
      return false;
    }
  }

  @Watch("pageIndex")
  onPageIndexChanged(newValue: number): void {
    this.maxAccessedPageIndex = Math.max(this.maxAccessedPageIndex, newValue);
  }

  @Watch("scales")
  onScalesChanged(newValue: number[], oldValue: number[]) {
    if (JSON.stringify(oldValue) !== JSON.stringify(newValue) && newValue && 0 < newValue.length) {
      this.initializeScale();
    }
  }

  @Watch("documentAlerts")
  async onDocumentAlertsChanged(newValue: IDocumentAlert[], oldValue: IDocumentAlert[]): Promise<void> {
    if (newValue && (newValue !== oldValue) && newValue.length > 0) {
      await this.$refs.alertDialog.show(this.document);
    }
  }
}
